module.exports = __webpack_public_path__ + "img/106024.0909cd08.png";